//# sourceMappingURL=label_translations.mjs.map
/// <reference types="./label_translations.d.mts" />
import * as $e from "../../../altar/redraw/dom/events/extra.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $translate from "../../../data_types/data/translate.mjs";
import * as $language from "../../../data_types/data/translate/language.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $combobox from "../../../ds/ds/components/combobox.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $skeleton from "../../../ds/ds/components/skeleton.mjs";
import * as $table from "../../../ds/ds/components/table.mjs";
import * as $global from "../../../ds/web/javascript/global.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $ref from "../../../redraw/redraw/ref.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $timestamp_ from "../../../tiamat/gleam/time/timestamp_.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $label_translations_effects from "../../admin/effects/label_translations.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList, prepend as listPrepend, isEqual } from "../../gleam.mjs";
import * as $common from "../../view/common.mjs";

const delete_all_confirmation_phrase = "DELETE ALL";

function confirm_delete() {
  return $redraw.component_(
    "ConfirmDeleteTranslation",
    (props) => {
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([]),
            toList([
              $modal.title(
                toList([]),
                toList([$h.text("Delete this cached translation?")]),
              ),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    "It will be asked again the next time it is needed. This cannot be undone.",
                  ),
                ]),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.secondary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.primary(
                    toList([on_confirm]),
                    toList([$h.text("Delete")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function confirm_delete_label() {
  return $redraw.component_(
    "ConfirmDeleteLabelTranslations",
    (props) => {
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([]),
            toList([
              $modal.title(
                toList([]),
                toList([$h.text("Delete every language of this label?")]),
              ),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    "All translations of this label — every language — will be asked again the next time they are needed. This cannot be undone.",
                  ),
                ]),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.secondary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.primary(
                    toList([on_confirm]),
                    toList([$h.text("Delete")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

/**
 * Type-to-confirm: the primary action only enables once the typed text
 * matches exactly, and the row count is shown so the scale of the action is
 * visible before it fires — this wipes the cache for every org at once.
 * 
 * @ignore
 */
function confirm_delete_all() {
  return $redraw.component_(
    "ConfirmDeleteAllLabelTranslations",
    (props) => {
      let store = $store.use_state();
      let $ = $redraw.use_state("");
      let typed = $[0];
      let set_typed = $[1];
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      let kind = $translate.translation_target_to_string(
        $label_translations_effects.kind(store.route),
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([]),
            toList([
              $modal.title(
                toList([]),
                toList([$h.text(("Delete every " + kind) + " translation?")]),
              ),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    "Every label, every language, every org. Each label will be\n           translated again from scratch the next time it is needed.\n           This cannot be undone.",
                  ),
                  $h.text(
                    ("Type \"" + delete_all_confirmation_phrase) + "\" to confirm.",
                  ),
                ]),
              ),
              $input.input(
                (() => {
                  let _pipe = $input.value(typed);
                  let _pipe$1 = $input.placeholder(
                    _pipe,
                    delete_all_confirmation_phrase,
                  );
                  return $input.on_input(_pipe$1, set_typed);
                })(),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.secondary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.primary(
                    toList([
                      on_confirm,
                      $a.disabled(typed !== delete_all_confirmation_phrase),
                    ]),
                    toList([$h.text("Delete everything")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

/**
 * Opens the confirm modal and fires the delete effect on confirmation.
 * Takes `confirm`, `modal_ctx` and `effect_dispatch` as plain values,
 * gathered once at the top of `view()` (via `redraw.compose` and the
 * `modal.use_modal()` / `store.use_effect_dispatch()` hooks) — hooks may
 * only run inside a component render, never per table row inside a
 * `list.map` loop.
 * 
 * @ignore
 */
function delete_click(confirm, modal_ctx, effect_dispatch, translation) {
  return (_) => {
    let _pipe = modal_ctx.open(confirm);
    $promise.map(
      _pipe,
      (result) => {
        if (result instanceof Ok) {
          effect_dispatch(
            $label_translations_effects.delete$(
              translation.id,
              translation.version,
            ),
          );
          return undefined;
        } else {
          return undefined;
        }
      },
    );
    return undefined;
  };
}

function delete_label_click(
  confirm_label,
  modal_ctx,
  effect_dispatch,
  target_id
) {
  return (_) => {
    let _pipe = modal_ctx.open(confirm_label);
    $promise.map(
      _pipe,
      (result) => {
        if (result instanceof Ok) {
          effect_dispatch($label_translations_effects.delete_label(target_id));
          return undefined;
        } else {
          return undefined;
        }
      },
    );
    return undefined;
  };
}

function delete_all_click(confirm_all, modal_ctx, effect_dispatch) {
  return (_) => {
    let _pipe = modal_ctx.open(confirm_all);
    $promise.map(
      _pipe,
      (result) => {
        if (result instanceof Ok) {
          effect_dispatch($label_translations_effects.delete_all());
          return undefined;
        } else {
          return undefined;
        }
      },
    );
    return undefined;
  };
}

function format_date(ts) {
  return $timestamp_.to_date_yyyymmdd(ts, "/");
}

function translation_row(
  translation,
  show_label,
  label,
  confirm,
  confirm_label,
  modal_ctx,
  effect_dispatch
) {
  return $table.row(
    toList([
      $table.cell(
        $l.row(
          toList([$l.gap(4), $l.align("center")]),
          toList([]),
          toList([
            $h.div(
              toList([]),
              toList([
                $h.text(
                  (() => {
                    if (show_label) {
                      return label;
                    } else {
                      return "";
                    }
                  })(),
                ),
              ]),
            ),
            (() => {
              if (show_label) {
                return $button.ghost(
                  toList([
                    $e.on_click(
                      delete_label_click(
                        confirm_label,
                        modal_ctx,
                        effect_dispatch,
                        translation.target_id,
                      ),
                    ),
                  ]),
                  toList([$h.text("Delete label")]),
                );
              } else {
                return $h.none();
              }
            })(),
          ]),
        ),
      ),
      $table.cell(
        $h.div(
          toList([]),
          toList([
            $h.text(
              ($language.to_emoji(translation.language) + " ") + $language.to_string(
                translation.language,
              ),
            ),
          ]),
        ),
      ),
      $table.cell($h.div(toList([]), toList([$h.text(translation.content)]))),
      $table.cell(
        $h.div(
          toList([]),
          toList([$h.text(format_date(translation.created_at))]),
        ),
      ),
      $table.cell(
        $button.ghost(
          toList([
            $e.on_click(
              delete_click(confirm, modal_ctx, effect_dispatch, translation),
            ),
          ]),
          toList([$h.text("Delete")]),
        ),
      ),
    ]),
  );
}

/**
 * Rows are already ordered by label (and then language) by the backend
 * query. A flat table with "Conforme" repeated on every language row read
 * as noise — the label column here only fills in on the first row of each
 * group, so every group of languages for one label reads as a single block.
 * 
 * @ignore
 */
function grouped_rows(
  translations,
  confirm,
  confirm_label,
  modal_ctx,
  effect_dispatch
) {
  let $ = $list.fold(
    translations,
    [new None(), toList([])],
    (acc, translation) => {
      let previous_label = acc[0];
      let rows = acc[1];
      let label = $option.unwrap(
        translation.metadata.source,
        translation.target_id,
      );
      let is_group_start = !isEqual(new Some(label), previous_label);
      let row = translation_row(
        translation,
        is_group_start,
        label,
        confirm,
        confirm_label,
        modal_ctx,
        effect_dispatch,
      );
      return [new Some(label), listPrepend(row, rows)];
    },
  );
  let rows = $[1];
  return $list.reverse(rows);
}

function sort_indicator(column, current) {
  if (current === (column + "_asc")) {
    return " ↑";
  } else if (current === (column + "_desc")) {
    return " ↓";
  } else {
    return "";
  }
}

/**
 * The other of a `_asc`/`_desc` pair, so clicking an already-active header
 * flips direction instead of doing nothing.
 * 
 * @ignore
 */
function toggled_sort(column, current) {
  if (current === (column + "_asc")) {
    return column + "_desc";
  } else {
    return column + "_asc";
  }
}

function sortable_header(title, column, sort, dispatch) {
  return $table.custom_header(
    $h.div(
      toList([
        $a.style(toList([["cursor", "pointer"], ["user-select", "none"]])),
        $e.on_click(
          (_) => {
            let _pipe = new $msg.UserRequestedLabelTranslationsSort(
              toggled_sort(column, sort),
            );
            let _pipe$1 = new $msg.LabelTranslations(_pipe);
            return dispatch(_pipe$1);
          },
        ),
      ]),
      toList([$h.text(title + sort_indicator(column, sort))]),
    ),
  );
}

function translations_table(
  translations,
  sort,
  confirm,
  confirm_label,
  modal_ctx,
  effect_dispatch,
  msg_dispatch
) {
  return $table.table(
    toList([]),
    toList([
      $table.headers(
        toList([
          (() => {
            let _pipe = sortable_header("Label", "label", sort, msg_dispatch);
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = sortable_header(
              "Language",
              "language",
              sort,
              msg_dispatch,
            );
            return $table.clamp(_pipe, "140px", 160);
          })(),
          (() => {
            let _pipe = $table.header("Translation");
            return $table.fit(_pipe);
          })(),
          (() => {
            let _pipe = sortable_header(
              "Created at",
              "created_at",
              sort,
              msg_dispatch,
            );
            return $table.clamp(_pipe, "120px", 140);
          })(),
          (() => {
            let _pipe = $table.header("");
            return $table.clamp(_pipe, "60px", 80);
          })(),
        ]),
      ),
      $table.body(
        grouped_rows(
          translations,
          confirm,
          confirm_label,
          modal_ctx,
          effect_dispatch,
        ),
      ),
    ]),
  );
}

function pagination_controls(page_index, page_count, dispatch) {
  return $l.row(
    toList([$l.gap(8), $l.align("center")]),
    toList([]),
    toList([
      $button.secondary(
        toList([
          $a.disabled(page_index <= 0),
          $e.on_click(
            (_) => {
              let _pipe = new $msg.UserRequestedLabelTranslationsPage(
                page_index - 1,
              );
              let _pipe$1 = new $msg.LabelTranslations(_pipe);
              return dispatch(_pipe$1);
            },
          ),
        ]),
        toList([$h.text("←")]),
      ),
      $h.div(
        toList([]),
        toList([
          $h.text(
            ($int.to_string(page_index + 1) + " / ") + $int.to_string(
              $int.max(page_count, 1),
            ),
          ),
        ]),
      ),
      $button.secondary(
        toList([
          $a.disabled(page_index >= (page_count - 1)),
          $e.on_click(
            (_) => {
              let _pipe = new $msg.UserRequestedLabelTranslationsPage(
                page_index + 1,
              );
              let _pipe$1 = new $msg.LabelTranslations(_pipe);
              return dispatch(_pipe$1);
            },
          ),
        ]),
        toList([$h.text("→")]),
      ),
    ]),
  );
}

function language_filter(store, dispatch, combobox_) {
  let _block;
  let _pipe = $combobox.on_selected(
    (selected) => {
      let _pipe = new $msg.UserRequestedLabelTranslationsLanguageFilter(
        selected,
      );
      let _pipe$1 = new $msg.LabelTranslations(_pipe);
      dispatch(_pipe$1);
      return undefined;
    },
  );
  let _pipe$1 = $combobox.selected(
    _pipe,
    store.label_translations_language_filter,
  );
  _block = $combobox.placeholder(_pipe$1, "All languages");
  let props = _block;
  let choices = $list.map(
    $language.all,
    (lang) => {
      return $combobox.choice(
        ($language.to_emoji(lang) + " ") + $language.to_string(lang),
        lang,
      );
    },
  );
  return combobox_([props, choices]);
}

function use_timer() {
  let ref = $redraw.use_ref();
  let cancel_timer = () => {
    return $function.tap(
      undefined,
      (_) => {
        return $option.map(
          $ref.current(ref),
          (timer) => {
            $global.clear_timeout(timer);
            return $ref.assign(ref, new None());
          },
        );
      },
    );
  };
  let store_timer = (timer) => {
    let timer$1 = new Some(timer);
    return $ref.assign(ref, timer$1);
  };
  return [store_timer, cancel_timer];
}

/**
 * Must be called unconditionally inside a component_ body — uses hooks.
 * Debounced: dispatching (and therefore re-fetching) on every keystroke
 * raced the input's own re-render, dropping characters when typed quickly.
 * 
 * @ignore
 */
function use_search_input(store, dispatch) {
  let $ = $redraw.use_state($option.unwrap(store.label_translations_search, ""));
  let content = $[0];
  let set_content = $[1];
  let $1 = use_timer();
  let store_timer = $1[0];
  let cancel_timer = $1[1];
  $redraw.use_effect_(
    () => {
      store_timer(
        $global.set_timeout(
          300,
          () => {
            return $function.tap(
              undefined,
              (_) => {
                let _block;
                if (content === "") {
                  _block = new None();
                } else {
                  let value = content;
                  _block = new Some(value);
                }
                let search = _block;
                let _pipe = new $msg.UserRequestedLabelTranslationsSearch(
                  search,
                );
                let _pipe$1 = new $msg.LabelTranslations(_pipe);
                dispatch(_pipe$1);
                return undefined;
              },
            );
          },
        ),
      );
      return cancel_timer;
    },
    [content],
  );
  return $input.input(
    (() => {
      let _pipe = $input.value(content);
      let _pipe$1 = $input.placeholder(
        _pipe,
        "Search a label or a translation…",
      );
      let _pipe$2 = $input.on_input(_pipe$1, set_content);
      return $input.wrapper_style(
        _pipe$2,
        $css.class$(toList([$css.width(px(650))])),
      );
    })(),
  );
}

export function view() {
  return $redraw.compose(
    confirm_delete(),
    (confirm) => {
      return $redraw.compose(
        confirm_delete_label(),
        (confirm_label) => {
          return $redraw.compose(
            confirm_delete_all(),
            (confirm_all) => {
              return $redraw.compose(
                $combobox.combobox(),
                (combobox_) => {
                  return $redraw.component_(
                    "LabelTranslations",
                    (_use0) => {
                      
                      let store = $store.use_state();
                      let dispatch = $store.use_effect_dispatch();
                      let msg_dispatch = $store.use_dispatch();
                      let modal_ctx = $modal.use_modal();
                      let kind = $label_translations_effects.kind(store.route);
                      $redraw.use_effect(
                        () => {
                          let _pipe = new $msg.UserRequestedLabelTranslationsPage(
                            0,
                          );
                          let _pipe$1 = new $msg.LabelTranslations(_pipe);
                          msg_dispatch(_pipe$1);
                          return undefined;
                        },
                        [$translate.translation_target_to_string(kind)],
                      );
                      return $l.column(
                        toList([$l.gap(12)]),
                        toList([]),
                        toList([
                          $l.row(
                            toList([$l.gap(12), $l.align("center")]),
                            toList([]),
                            toList([
                              $common.page_title(
                                (() => {
                                  if (kind instanceof $translate.Section) {
                                    return "Section translations";
                                  } else {
                                    return "Choice translations";
                                  }
                                })(),
                              ),
                              $button.primary(
                                toList([
                                  $button.color("red"),
                                  $e.on_click(
                                    delete_all_click(
                                      confirm_all,
                                      modal_ctx,
                                      dispatch,
                                    ),
                                  ),
                                ]),
                                toList([$h.text("Delete all")]),
                              ),
                            ]),
                          ),
                          $l.row(
                            toList([$l.gap(12), $l.align("center")]),
                            toList([]),
                            toList([
                              use_search_input(store, msg_dispatch),
                              $l.row(
                                toList([
                                  $l.gap(4),
                                  $l.align("center"),
                                  $l.styles(toList([$css.max_width_("220px")])),
                                ]),
                                toList([]),
                                toList([
                                  language_filter(
                                    store,
                                    msg_dispatch,
                                    combobox_,
                                  ),
                                ]),
                              ),
                              (() => {
                                let $ = store.label_translations_language_filter;
                                if ($ instanceof Some) {
                                  return $button.ghost(
                                    toList([
                                      $e.on_click(
                                        (_) => {
                                          let _pipe = new $msg.UserRequestedLabelTranslationsLanguageFilter(
                                            new None(),
                                          );
                                          let _pipe$1 = new $msg.LabelTranslations(
                                            _pipe,
                                          );
                                          return msg_dispatch(_pipe$1);
                                        },
                                      ),
                                    ]),
                                    toList([$h.text("Clear")]),
                                  );
                                } else {
                                  return $h.none();
                                }
                              })(),
                            ]),
                          ),
                          (() => {
                            let $ = store.label_translations;
                            if ($ instanceof $remote.NotLoaded) {
                              return $skeleton.full_width(400);
                            } else if ($ instanceof $remote.Loading) {
                              return $skeleton.full_width(400);
                            } else if ($ instanceof $remote.Errored) {
                              let error = $[0];
                              return $h.text("Error: " + error);
                            } else {
                              let pagination = $[0];
                              return $l.column(
                                toList([$l.gap(12)]),
                                toList([]),
                                toList([
                                  pagination_controls(
                                    pagination.page_index,
                                    pagination.page_count,
                                    msg_dispatch,
                                  ),
                                  translations_table(
                                    pagination.elements,
                                    store.label_translations_sort,
                                    confirm,
                                    confirm_label,
                                    modal_ctx,
                                    dispatch,
                                    msg_dispatch,
                                  ),
                                ]),
                              );
                            }
                          })(),
                        ]),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
